import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { pxToRems } from '@awaze/design-system.utils.react';
import styled, { css } from 'styled-components';
import { AccountMyaccountLogin } from '@awaze/design-system.components.icon';
import { icons } from './navigation-icons';
export const NavigationItemTextStyled = styled.span `
  ${({ isChild, isMobile, href = false, highlight, brand }) => {
    const mobileHeading = !!href === false;
    // Sub menu items
    return !isChild
        ? //  First level menu items
            css `
          display: flex;
          align-items: center;
          position: relative;
          text-decoration: none;
          color: ${({ theme }) => theme.ColorThemeTextHeaderLink};
          padding: 8px 12px;
          cursor: pointer;
          font-size: ${({ theme }) => pxToRems(theme.FontTextText200MidFontSize)};
          font-weight: ${({ theme }) => theme.FontTextText200MidFontWeight};

          svg[id='dropdown-icon'] {
            margin-left: 8px;
            background: transparent;
            path {
              fill: ${({ theme }) => theme.ColorThemeTextHeaderLink};
            }
          }

          svg {
            background: ${({ theme }) => brand === 'hoseasons'
                ? theme.ColorButtonSolidReverseBackground
                : theme.ColorButtonSolidPrimaryBackground};

            path {
              fill: ${({ theme }) => brand === 'hoseasons'
                ? theme.ColorButtonSolidReverseText
                : theme.ColorButtonSolidPrimaryText};
            }
          }

          ${highlight &&
                !isMobile &&
                css `
            background-color: ${({ theme }) => theme.ColorThemeButtonSecondaryAlt};
            color: ${({ theme }) => theme.ColorThemeTextHeaderButtonLink};
            border-radius: 4px;

            &:hover {
              background-color: ${({ theme }) => theme.ColorThemeButtonSecondaryAltHover};
            }

            svg > path {
              fill: ${({ theme }) => theme.ColorThemeTextHeaderButtonLink};
            }
          `}

          ${isMobile &&
                css `
            outline: none;
            text-align: left;
            padding: 11px 0;
            margin: 0;
            font-size: ${({ theme }) => pxToRems(theme.FontTextText400FontSize)};
            color: ${({ theme }) => theme.ColorGrey700};
            text-decoration: none;

            &:hover {
              background-color: transparent;
            }
          `}

          ${
            // Mobile styling
            isMobile &&
                mobileHeading &&
                css `
              font-size: ${({ theme }) => pxToRems(theme.FontTextText400FontSize)};
              font-weight: bold;
              color: ${({ theme }) => theme.ColorGrey700};
              padding: 0;
              margin-bottom: 10px;

              svg {
                path {
                  fill: ${({ theme }) => theme.ColorButtonSolidPrimaryText};
                }

                &:last-child {
                  margin-left: 0;
                }
              }
            `}
        `
        : // Second level menu items
            css `
          display: block;

          ${isMobile
                ? // Second level Mobile A,SPAN items
                    css `
                outline: none;
                text-align: left;
                padding: 6px 0;
                margin: 0;
                font-size: ${({ theme }) => pxToRems(theme.FontTextText300FontSize)};
                color: ${({ theme }) => theme.ColorTextBodyOnWhite};
                text-decoration: none;
              `
                : // Second level DESKTOP A,SPAN items
                    css `
                color: ${({ theme }) => theme.ColorThemeLink};
                text-decoration: none;
                padding: 6px 0;
                min-width: 209px;
                max-width: 670px;
                white-space: break-spaces;
                display: flex;
                align-content: center;
                width: -webkit-fill-available;

                &:hover {
                  text-decoration: underline;
                  color: ${({ theme }) => theme.ColorThemeLinkActive};
                }
              `}
        `;
}}
`;
export const AccountMyaccountLoginStyled = styled(AccountMyaccountLogin) `
  margin-right: 8px;
`;
export const NavigationItemText = (props) => {
    const { icon = null, highlight = false, isMobile = false, isChild = false, isDropdown = false, 
    // This is NOT only used for mobile, but also for desktop. It's a flag set in contentful
    // for enabling a login icon on the navigation item
    enableMobileLoginIcon = false, link = {
        href: null,
        openInNew: false,
        displayText: '',
    }, user, brand, } = props;
    const showAccountLoginIcon = (enableMobileLoginIcon && isMobile) ||
        (enableMobileLoginIcon && user?.email);
    const chosenIcon = showAccountLoginIcon ? (_jsx(AccountMyaccountLoginStyled, { size: isMobile ? 's' : 'm', "data-testid": "AccountMyaccountLoginIcon", iconColour: brand === 'hoseasons'
            ? 'ColorButtonSolidReverseText'
            : 'ColorButtonSolidPrimaryText', backgroundColour: brand === 'hoseasons'
            ? 'ColorButtonSolidReverseBackground'
            : 'ColorButtonSolidPrimaryBackground' })) : (icons[icon]);
    const showEmailOnMobile = enableMobileLoginIcon && isMobile && user?.email;
    const hideEmailOnDesktop = enableMobileLoginIcon && !isMobile && user?.email;
    const dropdownIcon = isDropdown && !user?.email ? icons.dropdown : null;
    // If login icon is enabled, show user email if available (logged in state)
    const displayText = hideEmailOnDesktop
        ? ''
        : showEmailOnMobile
            ? user.email
            : // If login icon is enabled, but no user email, show empty string (logged out state)
                link.displayText;
    return (_jsxs(NavigationItemTextStyled, { ...(link.href && {
            as: 'a',
            href: link.href,
            target: link.openInNew ? '_blank' : null,
        }), highlight,
        brand,
        isMobile,
        user,
        href: link.href,
        isChild, children: [chosenIcon, " ", displayText, " ", dropdownIcon] }));
};
//# sourceMappingURL=navigation-item-text.js.map